import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from "react-router-dom"
import MyCollection from './MyCollection'
import PlusButton from '../common/PlusButton'
import collectionStore from '../../stores/collectionStore'

@observer
class CollectionsSidebar extends Component {
  renderCollections() {
    const { positionMenu } = this.props
    return this.collections.map((collection, i) => (
      <MyCollection
        key={i}
        positionMenu={positionMenu}
        collection={collection}
        number={i}
      />
    ))
  }

  componentDidMount() {
    if (window.location.pathname !== "/my-collections" && this.props.store.collections.length === 0) this.props.store.fetch()
  }

  get collections() { return this.props.store.collections.slice(0, 10) }

  noCollectionsInfo = (loaded = false) => (
    <div className='pt-3.5 pb-5 text-center w-full'>
      { loaded ? "No Collections" : "Loading..." }
    </div>
  )

  render() {
    const { store, title, showAddButton } = this.props
    const anyCollections = !!store.collections.length;
    const { totalEntries, loaded } = store;
    return (
      <div className='flex flex-col mb-12'>
        {
          anyCollections && title && (
            <div className='flex justify-between items-center mb-5'>
              <p className='text-2xl font-bold leading-none'>{title}</p>
              {
                showAddButton && (
                  <PlusButton onClick={collectionStore.showCreateModal}/>
                )
              }
            </div>
          )
        }
        {
          anyCollections ? this.renderCollections() : this.noCollectionsInfo(loaded)
        }
        {
          totalEntries > 10 && (
            <Link
              to='/my-collections'
              className='cursor-pointer text-center pt-4 pb-5'
            >
              Load more
            </Link>
          )
        }
      </div>
    )
  }
}

export default CollectionsSidebar;
